import { Box, List, ListItem, ListItemText, Typography } from '@material-ui/core'
import React from 'react'

function SystemModelUpdateAlertContent({data}) {

    const getClusterletType = (type) => {
        if(type === 4) return "Physical Entity"
        if(type === 1) return "Delegate"
        if(type === 2) return "Digital Twin"
        if(type === 20) return "Enterprise Application"
        return "Clusterlet"
    }


    const  mainText = data?.deletedNodes?.length > 0 ? `Some components of this blueprint will be removed or modified. Sections, fields, and profiles associated with the selected nodes will be updated or removed as part of this change. This action may impact the blueprint’s structure and existing connections.` :
    `Some components of this blueprint will be removed or altered. Sections, fields, and profiles associated with the selected nodes will be removed or altered with this update. This action may impact the blueprint’s structure and existing connections.
    `


    return (
        <Box style={{padding: 14, color: 'black' }}>
           
          <Typography style={{marginBottom: 10}} >{mainText}</Typography>
  
          {/* Nodes to delete */}
          {data?.deletedNodes?.length > 0 && <> 
            <Typography >Deleting nodes will result in updates to associated transactions and associated events. The following nodes are marked for deletion:</Typography>
            <List dense style={{ listStyleType: 'disc', paddingLeft: 24 }}>
              {data?.deletedNodes?.map((item) => (
                <ListItem key={item.name} style={{ display: 'list-item', paddingTop: 0, paddingBottom: 0 }} >
                  <ListItemText
                    primary={`${item.name} (${getClusterletType(item.type)})`}
                  />
                </ListItem>
              ))}
            </List>
          </>}
  
          {/* Affected Transactions */}
          {data?.transactions?.length > 0 && <> 
            <Typography > As a result, the following transactions will be updated to remove deleted nodes, their associated events, or events related to removed connections:</Typography>
            <List dense style={{ listStyleType: 'disc', paddingLeft: 24 }}> 
              {data?.transactions?.map(item => (
                 <ListItem key={item.name} style={{ display: 'list-item', paddingTop: 0, paddingBottom: 0 }} >
                  <ListItemText primary={item.name} />
                </ListItem>
              ))}
            </List>
          </>}
  
          {/* Simulations */}
          {data?.testcases?.length > 0 && <> 
            <Typography > Changes to the transaction structure will also impact related testcases. The following testcases will be updated to reflect the latest transaction changes:</Typography>
            <List dense style={{ listStyleType: 'disc', paddingLeft: 24 }}>   
              {data?.testcases?.map(item => (
                  <ListItem key={item.name} style={{ display: 'list-item', paddingTop: 0, paddingBottom: 0 }} >
                    <ListItemText primary={`${item.name } (${item.parent?.name  })` }  />
                  </ListItem>
              ))}
            </List>
          </>}
  
          {/* Views */}
          {data?.views?.length > 0 && <> 
            <Typography > Changes to the transaction structure will also impact related views. The following views uses the affected transactions in it:</Typography>
            <List dense style={{ listStyleType: 'disc', paddingLeft: 24 }}>   
              {data?.views?.map(item => (
                  <ListItem key={item.name} style={{ display: 'list-item', paddingTop: 0, paddingBottom: 0 }} >
                    <ListItemText primary={`${item.name }` }  />
                  </ListItem>
              ))}
            </List>
          </>}
  
  
          {/* Routing rules */}
          {data?.modifiedDelegates?.length > 0 && <> 
            <Typography  >Changing the delegate type will cause the associated routing rules to become invalid. Routing rules linked to the following delegates will no longer function after this update:
            </Typography>
            
            <List dense style={{ listStyleType: 'disc', paddingLeft: 24 }}> 
              {data?.modifiedDelegates?.map(item => (
                    <ListItem key={item.name} style={{ display: 'list-item', paddingTop: 0, paddingBottom: 0 }} >
                      <ListItemText primary={item.name} />
                    </ListItem>
              ))}
            </List>
          </>}
  
  
          <Typography style={{fontWeight: 500}} >
            Are you sure you want to proceed ?
          </Typography>
        </Box>
  )
}

export default SystemModelUpdateAlertContent